import { useMemo } from 'react'
import { useInfiniteQuery } from 'react-query'

import type PaginationDomain from '../../../../../../types/domain/pagination-domain'
import { type ResearcherDomain } from '../../../../../../types/domain/researcher-domain'
import { api } from '../../../../../../services/api'

export const useInfiniteResearchersSelectOptions = (
  searchResearcher: string,
  selectedResearcher?: ResearcherDomain
) => {
  const infiniteResearchers = useInfiniteQuery<
  PaginationDomain<ResearcherDomain>
  >(
    ['research-select', searchResearcher],
    ({ pageParam = 1 }) =>
      api
        .get(
          `/researchers?page=${pageParam}&search=${searchResearcher}&sort=name&order=ASC`
        )
        .then((response) => response.data),
    {
      getNextPageParam ({ meta }) {
        return meta?.hasNextPage ? meta?.page + 1 : undefined
      },
    }
  )

  const generateResearcherSelectOptions = () => {
    const researcherOptions = infiniteResearchers.data?.pages
      .reduce(
        (
          acc: ResearcherDomain[],
          { data }: PaginationDomain<ResearcherDomain>
        ) => {
          return [...acc, ...data]
        },
        []
      )
      .map(({ id, name }: ResearcherDomain) => ({
        label: name,
        value: String(id),
      }))

    if (!researcherOptions) {
      return []
    }

    if (selectedResearcher) {
      const { id, name } = selectedResearcher
      return [
        { label: 'Sem researcher', value: '' },
        { label: name, value: String(id) },
        ...researcherOptions.filter(
          (researcherOption: Record<string, string>) => {
            return researcherOption.value !== String(id)
          }
        ),
      ]
    }

    return [{ label: 'Sem researcher', value: '' }, ...researcherOptions]
  }

  const options = useMemo(generateResearcherSelectOptions, [
    infiniteResearchers,
  ])

  return {
    options,
    ...infiniteResearchers,
  }
}
